import React from 'react';
import classNames from 'classnames';
import './styles.scss';

const CustomMaterialButton = (props) => {

  // Usa classNames para combinar la clase por defecto con la clase personalizada pasada como prop (si existe)
  const buttonClass = classNames('buttonCircle', props.containerClassName);
  const iconClass = classNames('material-icons', props.iconClassName);

  return (
    <button className={buttonClass} onClick={props.goBack}>
      <i className={iconClass}>
        {props.materialIcon}
      </i>
    </button>
  );
};


export default CustomMaterialButton;